import React, { useState, useEffect, useRef } from 'react';
import { Provider, useSelector, useDispatch } from 'react-redux';
import {
  Modal,
  Avatar,
  TimePicker,
  Radio,
  Divider,
  Typography,
  Button,
  InputNumber,
  message as Message,
  ConfigProvider,
} from 'antd';
// import { FaCcVisa, FaCreditCard } from 'react-icons/fa';
import { RadioChangeEvent } from 'antd/lib/radio';
import i18n from 'i18next';
import CZ from 'antd/lib/locale-provider/cs_CZ';
import IT from 'antd/lib/locale-provider/it_IT';
import EN from 'antd/lib/locale-provider/en_US';
import 'moment/locale/cs';
import 'moment/locale/it';

import { Meal } from '../../store/meals/types';
import { orderSentModalHandler } from './components/OrderSent';
import { store } from '../../store';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import { placeOrder } from '../../store/meals/actions';
import moment from 'moment';
import { setError } from '../../store/app-globals/actions';
import { FaCreditCard } from 'react-icons/fa';
import { colors } from '../../constants/colors';
import { getCustomerState } from '../../store/payment/selectors';

export interface PlaceOrderProps {
  meal: Meal;
  history: any;
}

export const GlobalModalProps = {
  icon: null,
  false: true,
  maskClosable: true,
  className: 'modal-content-container modal-content-description',
  okButtonProps: { style: { display: 'none' } },
};

export const closeModal = () => {
  Modal.destroyAll();
};

export const PlaceOrder: React.FC<PlaceOrderProps> = ({ meal, history }) => {
  const { isLoading, message, hasError, errorMessage } = useSelector(
    getAppGlobalState
  );
  // const { user } = useSelector(getUserState);
  // const { cards } = useSelector(getBankState);
  const { customers, selected } = useSelector(getCustomerState);
  const [orderTotal, setOrderTotal] = useState(Number(meal.price));
  const [portions, setPortions] = useState<number>(1);
  const [time, setTime] = useState<string>('');
  const [consumption, setConsumption] = useState<string>('');
  const [disabled, setDisabled] = useState(true);
  const isSendingOrder = useRef(false);
  const { cookDetails } = meal;
  const dispatch = useDispatch();
  const Dinner = `${moment('23:00', 'HH:mm').format('HH:mm')}`;
  const currentTime = moment().format('HH:mm');
  const isEndTime = currentTime > Dinner;

  const onNumberPickerChange = (value: number | undefined) => {
    setPortions(value || 1);
    setOrderTotal(Number(meal.price) * (value ? value : 1));
  };

  const onRadioGroupChange = (e: RadioChangeEvent) => {
    setConsumption(e.target.value);
  };

  const handleSendOrderButton = () => {
    const order = {
      mealid: meal.id,
      portions,
      consumptiondate: time,
      consumption,
      mealprice: meal.price,
      ordertotal: orderTotal.toFixed(2),
      cook: meal.cook,
      quantity: meal.portions - portions,
    };
    if (meal.portions === 0) {
      Message.error(
        `The offer has zero quantity, the cook must update this offer to proceed.`
      );
      return;
    }
    // const cardfilter = cards.filter(
    //   item => item.selected && item.user === user.userid
    // );
    // console.log('wew', cardfilter);
    // if (cardfilter.length === 0) {
    //   Message.error('You have to add a card to send an order');
    //   return;
    // }
    dispatch(placeOrder(order));
    isSendingOrder.current = true;
  };

  const validate = () => {
    if (time === '') {
      setDisabled(true);
    }
    if (portions && time) {
      setDisabled(false);
    }
    // if (portions && time && consumption) {
    //   setDisabled(false);
    // }
  };

  const sendingOrder = () => {
    if (isSendingOrder.current && !isLoading && !hasError) {
      closeModal();
      orderSentModalHandler();
    }

    if (isSendingOrder.current && !isLoading && hasError) {
      Message.error(i18n.t('Something went wrong'));
      console.log(errorMessage);
      dispatch(setError(false, ''));
    }
  };

  const disableTimeMinutes = (hour: number) => {
    const disabledMinutes = [10, 20, 30, 40, 50];
    const currentHour = Number(moment().format('H'));
    const currentMinutes = Number(moment().format('m'));
    const newArray = [0];
    if (currentHour >= hour) {
      disabledMinutes.map(n => {
        if (n <= currentMinutes) {
          newArray.push(n);
        }
        return n;
      });
    }
    return currentHour >= hour ? newArray : [];
  };

  const disableTimeHours = () => {
    const disabledHours = [1, 2, 3, 4, 5, 6];
    const currentHour = Number(moment().format('H'));

    for (let index = 0; index < currentHour; index++) {
      disabledHours.push(index);
    }
    return disabledHours;
  };

  const timePickerHandler = (time: any, timeString: string) => {
    const hours = moment(time).format('H');
    if (Number(hours) < 6) {
      setTime('');
      return;
    }
    if (time === null) {
      setTime('');
      return;
    }
    setTime(time.toDate());
  };

  useEffect(validate, [portions, time, consumption]);
  useEffect(sendingOrder, [isLoading]);
  const addPaymentCard = () => {
    history.push('/payment');
    Modal.destroyAll();
  };
  const filterCard = () => {
    const cardfilter = customers.filter(c => c.id === selected);
    return cardfilter;
  };
  return (
    <div>
      <div className="modal-content-wrapper">
        <div className="modal-title">{i18n.t('OFFER_ORDER')}</div>

        <div className="cook-details">
          <div>
            <Avatar src={cookDetails?.image} />
            <span>{cookDetails?.firstName}</span>
          </div>
          <div className="meal-title">{meal.title}</div>
        </div>

        <div className="meal-selectors">
          <div className="meal-pickers">
            <div className="selector-title">
              <span>{i18n.t('Quantity')}</span>
            </div>
            <InputNumber
              value={portions}
              min={1}
              max={meal.portions}
              defaultValue={1}
              onChange={onNumberPickerChange}
            />
          </div>
          <div className="meal-pickers">
            <div className="selector-title">
              <span>{i18n.t('TODAY')}</span>
            </div>
            <ConfigProvider
              locale={
                i18n.language === 'cz' ? CZ : i18n.language === 'it' ? IT : EN
              }
            >
              <TimePicker
                format="HH:mm"
                minuteStep={10}
                onChange={timePickerHandler}
                disabledHours={() => disableTimeHours()}
                disabledMinutes={hour => disableTimeMinutes(hour)}
                disabled={isEndTime}
              />
            </ConfigProvider>
          </div>
          {/* <div className="meal-radio-picker">
            <Radio.Group
              buttonStyle="solid"
              value={consumption}
              onChange={onRadioGroupChange}
            >
              {meal.consumption === 'Both' ? (
                <React.Fragment>
                  <Radio.Button
                    value="Take away"
                    className="radio-button-left-radius"
                  >
                    {i18n.t('Take away')}
                  </Radio.Button>
                  <Radio.Button
                    value="Eat with"
                    className="radio-button-right-radius"
                  >
                    {i18n.t('Eat with')}
                  </Radio.Button>
                </React.Fragment>
              ) : (
                <Radio.Button
                  value={meal.consumption}
                  className="meal-radio-group"
                >
                  {i18n.t(`${meal.consumption}`)}
                </Radio.Button>
              )}
            </Radio.Group>
          </div> */}
        </div>
      </div>

      <Divider />

      <div className="modal-content-wrapper">
        <div className="meal-order-payment">
          {/* <div className="meal-payment meal-cc-card">
            {filterCard().length ? (
              filterCard().map((item, i) => (
                <div key={i} onClick={addPaymentCard}>
                  <Button type="link" style={{ display: 'flex' }}>
                    <FaCreditCard
                      color={colors.blue}
                      size={23}
                      style={{ marginInline: 5 }}
                    />
                    {item.customers.card.last4}
                  </Button>
                </div>
              ))
            ) : (
              <Button
                type="link"
                style={{ display: 'flex' }}
                onClick={addPaymentCard}
              >
                <FaCreditCard
                  color={colors.blue}
                  size={23}
                  style={{ marginInline: 5 }}
                />
                <span style={{ marginLeft: 10 }}> Add Card </span>
              </Button>
            )}
          </div> */}
          <div className="meal-payment meal-payment-total">
            {i18n.t('Total Price')}
            <Typography.Title level={4}>
              {`Kč ${orderTotal.toFixed(2)}`}
            </Typography.Title>
          </div>
        </div>

        <Button
          block
          type="primary"
          shape="round"
          disabled={disabled}
          loading={isLoading}
          onClick={handleSendOrderButton}
          className="continue-button continue-button-primary"
        >
          <span className="continue-button-text">
            {i18n.t(`${message}`) || i18n.t('SEND_ORDER')}
          </span>
        </Button>
        <Button
          block
          shape="round"
          className="cancel-button cancel-button-primary"
          onClick={closeModal}
        >
          <span className="continue-button-text">{i18n.t('Cancel')}</span>
        </Button>
      </div>
    </div>
  );
};

export const PlaceOrderHandler = ({ meal, history }: PlaceOrderProps) => {
  Modal.info({
    ...GlobalModalProps,
    style: { top: 30 },
    content: (
      <Provider store={store}>
        <PlaceOrder meal={meal} history={history} />
      </Provider>
    ),
  });
};
